import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import Constants from "../../Constants";
import $ from "jquery";
import Select from 'react-select';
import ReactTooltip from 'react-tooltip';
import { getAxiosResponse, putAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { dateConvertToTimeStamp, humanize } from "../../services/Util";
import { RotatingLines } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";
import images from "../../images";

export default function CustomerVendor() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const focusRef = useRef();
  const navigate = useNavigate();
  const editButtonRef = useRef()

  const bootstrapData = useSelector(
    (reduxStore) => reduxStore.customer_bootstrap_data
  ).value;

  const showIntendentModel = (e, selectedVendor) => {
    document.body.classList.add("modal-open");
    editButtonRef.current = e.target;
   
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $("#addDepartment").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          if (e.shiftKey === true) {
            e.preventDefault();
            $("#saveId").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        let allAreFalse = true;
        $('#addDepartment').each(function() {
          if ($(this).find('input').attr('aria-expanded') !== 'false') {
            allAreFalse = false;
            return false;
          }
        });
        if (e.key === Constants.ESCAPE && allAreFalse) {
           hideIntendentModel();
            $('.focusAdd').trigger('focus');
            $('.btnClick').removeClass('focusAdd');
        }
      });
    }, 200);

		$(".global-dropdown-block .w-100").removeClass('hide')

    vendors.map((vendor) => {
      if(vendor.id === selectedVendor.id) {
        let preferredDepartments = vendor.userGroups?.map((userGroup) => userGroup.id);
        let unassignedDepts = [{label: `${t('select_one_department')}`, value: Constants.BLANK}];
        allDepartments.map((ug) => {
          if(!preferredDepartments.includes(ug.id)) {
            unassignedDepts.push({label: ug.name, value: ug.id})
          }
        });
        setUnassignedDepartments(unassignedDepts);
        setPreferredVendorDepartments(vendor.userGroups)
        setActivePopupId(selectedVendor.id)
        setActivePopupVendorName(selectedVendor.name);
      }
    })
  }
  const showIntendentModelonKeydown =(e, selectedVendor)=>{
    if (e.key === Constants.ENTER) {
      showIntendentModel(e, selectedVendor)
    }
  }
  const handleKeyOkflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $(".cw__input").trigger("focus");
      }
    }
  };
  const hideIntendentModel = () => {
    document.body.classList.remove("modal-open");
    if($(editButtonRef.current).length)
  	$(".global-dropdown-block .w-100").addClass('hide')
 };
 $(document).on("click",".btnClick",function() {
  $(this).addClass('focusAdd');
});
$(document).on("click",".first-focus",function() {
 $('.focusAdd').trigger('focus');
 $('.btnClick').removeClass('focusAdd');
});

 const [industries, setIndustries] = useState([]);
 const [allIndustries, setAllIndustries] = useState([]);
 const [vendors, setVendors] = useState([]);
 const [topLanguagePairs, setTopLanguagePairs] = useState([]);
 const [vendorIndustries, setVendorIndustries] = useState([]);
 const [preferredVendorDepartments, setPreferredVendorDepartments] = useState([]);
 const [unassignedDepartments, setUnassignedDepartments] = useState([]);
 const [allDepartments, setAllDepartments] = useState([]);
 const [groupsToAdd, setGroupsToAdd] = useState([]);
 const [groupsToRemove, setGroupsToRemove] = useState([]);
 const [activePopupId, setActivePopupId] = useState(null);
 const [activePopupVendorName, setActivePopupVendorName] = useState("");
 const [globalOverlay, showGlobalOverlay] = useState(false);
 const [allLanguages, setAllLanguages] = useState([]);
 const [sourceLanguages, setSourceLanguages] = useState([]);
 const [targetLanguages, setTargetLanguages] = useState([]);
 const [selectedSourceLanguage, setSelectedSourceLanguage] = useState([]);
 const [selectedTargetLanguages, setSelectedTargetLanguages] = useState([]);
 const [selectedIndustries, setSelectedIndustries] = useState([]);
 const [selectPreferredVendor, setSelectPreferredVendor] = useState(false);
 const [selectNotPreferredVendor, setSelectNotPreferredVendor] = useState(false);
 const [selectInternalTranslator, setSelectInternalTranslator] = useState(false);

 useEffect(() => {
  showGlobalOverlay(true);
  getAxiosResponse(APIUrls.GET_ALL_LANGUAGES)
  .then((res) => {
    const options = res.data.data.map((lang) => ({
      label: lang.display,
      value: lang.code,
      display: lang.language
    }))
    setSourceLanguages(options);
    setTargetLanguages(options);
    setAllLanguages(options);
  }).catch(err=>{
    console.error(err)
  })

  getAxiosResponse(APIUrls.GET_ALL_INDUSTRIES_AVAILABLE)
  .then((res) => {
    let data=res?.data?.data;
    if(data && data.length > 0){
      const options = data.map((industry) => ({
        label: industry.display,
        value: industry.key,
        display: industry.value
      }))
      setIndustries(options);
      setAllIndustries(options);
    }
  }).catch(err=>{
    console.error(err)
  })

  getAxiosResponse(APIUrls.VENDOR_FILTERS)
  .then((res) => {
    let resource=res?.data?.data?.resource?.result
    if(resource && resource?.length > 0){
      setVendors(res.data.data.resource.result);
      setTopLanguagePairs(res.data.data.displayName[0]);
    }
    showGlobalOverlay(false);
  }).catch(err=>{
    console.error(err)
  })

  getAxiosResponse(APIUrls.ALL_DEPARTMENT)
  .then((res) => {
    setAllDepartments(res?.data?.data);
  }).catch(err=>{
    console.error(err)
  })
  focusRef.current?.focus()
 }, [])

 useEffect(() => {
  $('.lastdisable').trigger('focus');
}, []);

 useEffect(() => {
  showGlobalOverlay(true);
  fetchFilteredVendors();
 }, [selectPreferredVendor, selectNotPreferredVendor, selectInternalTranslator, selectedTargetLanguages, selectedIndustries])

 const fetchFilteredVendors = () => {
  const dateTimestamp = dateConvertToTimeStamp();
  let filterUrl = `?_=${dateTimestamp}`;
    if(selectPreferredVendor) {
      filterUrl += '&v_cp=true';
    }
    if(selectNotPreferredVendor) {
      filterUrl += '&v_cp=false';
    }
    if(selectInternalTranslator) {
      filterUrl += '&v_t=true';
    }
    if(selectedTargetLanguages.length > 0) {
      selectedTargetLanguages.map((targetLang) => {
        filterUrl += '&v_lp=' + selectedSourceLanguage[0].value + "__" + targetLang.value;
      })
    }
    if(selectedIndustries.length > 0) {
      selectedIndustries.map((industry) => {
        filterUrl += '&v_i=' + industry.value
      })
    }
    Promise.all([
      getAxiosResponse(APIUrls.CUSTOMER_PREFERRED_VENDORS),
      getAxiosResponse(APIUrls.VENDOR_FILTERS + filterUrl)
    ]).then(async ([customerPreferredVendors, vendorById]) => {
      if(customerPreferredVendors?.data?.code === 200) {
      vendorById?.data?.data?.resource?.result.map((dataItem) => {
        if(dataItem?.roleType?.value !== Constants.ROLE_INTERNAL_TRANSLATOR) {
          let vendorDetails = customerPreferredVendors?.data?.data?.filter((pv) => pv.vendor.id === dataItem.id);
          let depts = vendorDetails?.map((vendorData) => vendorData?.userGroup);
          dataItem.userGroups = depts;
        }
      });
      setVendors(vendorById?.data?.data?.resource?.result);
      setTopLanguagePairs(vendorById?.data?.data?.displayName[0]);
      setVendorIndustries(vendorById?.data?.data?.displayName[1]);
      showGlobalOverlay(false);
    }
    }).catch(err=>{
      console.error(err)
    })
 }

 const handleDepartmentSelection = (value) => {
    if(value.value !== Constants.BLANK) {
      let deptToBeAdded = {
        applicationVersion : "",
        createdDate : "",
        id : value?.value,
        name : value?.label,
        path : "",
        systemGroup : false
      }
      vendors.map((vendor) => {
        if(vendor.id === activePopupId) {
          let isPreferred = vendor.userGroups?.filter((ug) => ug.id === value.value).length === 1;
          if(!isPreferred) {
            setGroupsToAdd([...groupsToAdd, value?.value]);
          }
          if(groupsToRemove.includes(value.value)) {
            setGroupsToRemove(groupsToRemove.filter((group) => group !== value.value))
          }
        }
      })
      setPreferredVendorDepartments([...preferredVendorDepartments, deptToBeAdded]);
      setUnassignedDepartments(unassignedDepartments.filter((dept) => dept.value !== value.value));
    }
  }

  const removeDepartment = (userGroup) => {
    vendors.map((vendor) => {
      if(vendor.id === activePopupId) {
        let isPreferred = vendor?.userGroups?.filter((ug) => ug.id === userGroup?.id).length === 1;
        if(isPreferred) {
          setGroupsToRemove([...groupsToRemove, userGroup?.id]);
        }
        if(groupsToAdd.includes(userGroup.id)) {
          setGroupsToAdd(groupsToAdd.filter((group) => group !== userGroup?.id))
        }
      }
    })
    setUnassignedDepartments([...unassignedDepartments, {label: userGroup.name, value: userGroup?.id}])
    setPreferredVendorDepartments(preferredVendorDepartments.filter((group) => group.id !== userGroup?.id));

    const selectedElement = $(document.activeElement).closest(".multiselect-output");
		if($(document.activeElement).is(':last-child') &&
			selectedElement.children().length > 1){
				selectedElement.find('button:nth-last-child(2)').trigger('focus');
		} else if($(document.activeElement).is(':last-child')){
			$(document.activeElement).closest(".inner-lightbox-panel").find('.w-100 input:first-of-type').trigger('focus');
		}

  }

  const removeDepartmentonKeydown =(event, userGroup) => {
		if (event.key === Constants.ENTER) {
			removeDepartment(userGroup);
		}
	}

  const updatePreferredVendors = () => {
    let groupsToBeUpdated = {
      groupsToAdd : groupsToAdd,
      groupsToRemove : groupsToRemove,
      id : -1
    }
    putAxiosResponse(APIUrls.UPDATE_PREFERRED_VENDORS(activePopupId), groupsToBeUpdated)
    .then((res) => {
      if(res.data?.data?.statusCodeValue === 200) {
        hideIntendentModel();
        setTimeout(function() {
          fetchFilteredVendors();
        },1000)
      }
    }).catch(err=>{
      console.error(err)
    })
  }

  const updatePreferredVendorSelection = (e) => {
    if(e.target.id === Constants.PREFERRED_FILTER) {
      if(selectNotPreferredVendor) {
        setSelectNotPreferredVendor(!e.target.checked);
        setSelectPreferredVendor(e.target.checked);
      } else {
        setSelectPreferredVendor(e.target.checked);
      }
    }
    if(e.target.id === Constants.NON_PREFERRED_FILTER) {
      if(selectPreferredVendor) {
        setSelectPreferredVendor(!e.target.checked);
        setSelectNotPreferredVendor(e.target.checked);
      } else {
        setSelectNotPreferredVendor(e.target.checked);
      }
    }
  }

  const updateSelectedSourceLanguage = (value) => {
    setSelectedSourceLanguage([value]);
    let filteredLanguageList = allLanguages.filter((lang) => lang.value !== value.value);
    setSourceLanguages(filteredLanguageList);
    setTargetLanguages(filteredLanguageList);
      setTimeout(() => {
        $('.focus-source-lang button').trigger('focus');
      }, 200);


  }

  const removeSelectedSourceLanguage = () => {
    setSelectedSourceLanguage([]);
    setSelectedTargetLanguages([]);
    setSourceLanguages(allLanguages);
    setTargetLanguages(allLanguages);
    setTimeout(() => {
      $(".focus-source-lang input").trigger('focus')
    }, 300);
  }

  const updateSelectedTargetLanguages = (value) => {
    setSelectedTargetLanguages(selectedTargetLanguages => [...selectedTargetLanguages, value])
    let filteredLanguageList = allLanguages.filter((lang) => lang.value !== value.value && lang.value !== selectedSourceLanguage[0].value);
    setTargetLanguages(filteredLanguageList.filter((fll) => !selectedTargetLanguages.includes(fll)));
  }

  const removeSelectedTargetLanguage = (languageToRemove) => {
    setSelectedTargetLanguages(selectedTargetLanguages.filter((selected) => selected.value !== languageToRemove.value));
    setTargetLanguages(targetLanguages => [...targetLanguages, languageToRemove]);

    const selectedElement = $(document.activeElement).closest(".multiselect-output");
		if($(document.activeElement).is(':last-child') &&
			selectedElement.children().length > 1){
				selectedElement.find('button:nth-last-child(2)').trigger('focus');
		} else if($(document.activeElement).is(':last-child')){
			$(document.activeElement).closest(".role-and-department").find('.global-dropdown-select input:first-of-type').trigger('focus');
		}
  }

	const removeSelectedLanguageonKeydown =(event, languageToRemove) => {
		if (event.key === Constants.ENTER) {
			removeSelectedTargetLanguage(languageToRemove);
		}
	}

  const updateSelectedIndustries = (value) => {
    setSelectedIndustries(selectedIndustries => [...selectedIndustries, value]);
    let filteredIndustryList = allIndustries.filter((industry) => industry.value !== value.value);
    setIndustries(filteredIndustryList.filter((fil) => !selectedIndustries.includes(fil)));
  }

  const removeSelectedIndustry = (industryToRemove) => {
    setSelectedIndustries(selectedIndustries.filter((selected) => selected.value !== industryToRemove.value));
    setIndustries(industries => [...industries, industryToRemove]);

    const selectedElement = $(document.activeElement).closest(".multiselect-output");
		if($(document.activeElement).is(':last-child') &&
			selectedElement.children().length > 1){
				selectedElement.find('button:nth-last-child(2)').trigger('focus');
		} else if($(document.activeElement).is(':last-child')){
			$(document.activeElement).closest(".role-and-department").find('.global-dropdown-select input:first-of-type').trigger('focus');
		}
  }

	const removeSelectedOnKeydown =(event, industryToRemove) => {
		if (event.key === Constants.ENTER) {
			removeSelectedIndustry(industryToRemove);
		}
	}
  const [refs, setRefs] = useState({});
  const supportVendorRef = useRef(null);
     $('.tooltip-container p').on('keydown', function(e){
    if(e.key === Constants.ESCAPE){
      if ($(this).attr('id') === "supportVendorTooltip") {
        setRefs(supportVendorRef);
      }
    }
  });
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const handleTooltipToggle = () => {
    setTooltipVisible((prevState) => !prevState);
    $(document).mouseup(function(e) {
      var bannerCont = $('.vendor-link.ml-15');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        setTooltipVisible(false);
      }
    });
  };
  const EnterTooltipToggle = (e) => {
    if (e.key === Constants.ENTER) {
       setTooltipVisible((prevState) => !prevState);
     }
     if (e.key === Constants.ESCAPE && e.target.ariaExpanded === 'true') {
      setTooltipVisible((prevState) => !prevState);
      $(".knowMoreFocus").trigger("focus");
    }
    if (e.key === Constants.TAB && e.shiftKey) {
      setTooltipVisible((prevState) => !prevState);
      $(".knowMoreFocus").trigger("focus");
    }
  }
  const handleTooltipFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      setTooltipVisible((prevState) => !prevState);
      $(".knowMoreFocus").trigger("focus");
    }
    if (document.activeElement.id === 'letUsKnow') {
      if (event.key === Constants.TAB && !event.shiftKey) {
        event.preventDefault();
        setTooltipVisible((prevState) => !prevState);
        $(".knowMoreFocus").trigger("focus");
      }
    }
  }
  
  
  useEffect(()=>{
   if (refs.current) {
      refs.current.hideTooltip();
      setRefs({});
    }
  }, [refs]);
  const crumbs = [{label:'Vendor', url:''}];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap campaign-section">
            <Breadcrumb crumbs={crumbs} />
            <div className="customer-vendor-page">
              <div className="project-heading userprofile-heading">
                <h3>Vendors</h3>
              </div>
              <div className="flex customer-vendor-wrap">
                <div className="translate-type profile-editonly-block">
                  <div className="role-and-department">
                    <div className="tooltip-container vendor-tooltip">
                      <div className="heading-width-border changebottom-color flex w-d100">
                        <h5 className="">
                          {translate(
                            "cust_vendor.facet_supported_language_pairs"
                          )}
                        </h5>
                        <p
                          tabindex={0}
                          data-events={["focus"]}
                          data-eventsoff={["blur"]}
                          data-padding="10px 10px 10px 10px"
                          data-place="right"
                          data-tip
                          data-for="support-Vendor-tooltip"
                          aria-label="Tooltip"
                          id="supportVendorTooltip"
                          className="m-0 flex"
                        >
                          <svg
                            className="svg-tooltip-icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                          </svg>
                          <div className="font-zero">
                             tooltip
                              {translate("cust_vendor.language_tooltip_heading")}
                           
                            
                              {translate("cust_vendor.language_tooltip_text")}
                            
                          </div>
                        </p>
                        <ReactTooltip
                          className="tooltip"
                          id="support-Vendor-tooltip"
                          role="tooltip"
                          ref={supportVendorRef}
                        >
                          <strong>
                            {translate("cust_vendor.language_tooltip_heading")}
                          </strong>
                          <p className="mb-0">
                            {translate("cust_vendor.language_tooltip_text")}
                          </p>
                        </ReactTooltip>
                      </div>
                    </div>

                    <div className="profile-edit-form">
                      <div className="flex wrap-dropdown">
                        <div className="global-dropdown-block flex-center focus-source-lang">
                          <label>
                            {translate("cust_vendor.facet_source_language")}
                          </label>
                          {selectedSourceLanguage.length === 0 ? (
                            <Select
                              aria-label="From Source Language"
                              classNamePrefix="cw"
                              ref={focusRef}
                              className="global-dropdown-select"
                              menuShouldScrollIntoView={false}
                              closeMenuOnSelect={true}
                              options={sourceLanguages}
                              value={{
                                label: translate(
                                  "cust_vendor.select_source_language_placeholder"
                                ),
                                value: Constants.BLANK,
                              }}
                              onChange={(value) =>
                                updateSelectedSourceLanguage(value)
                              }
                            />
                          ) : (
                            <div className="multiselect-output flex">
                              {selectedSourceLanguage &&
                                selectedSourceLanguage.map((language) => {
                                  return (
                                    <button
                                      aria-label={"Remove " + language.label}
                                      onClick={removeSelectedSourceLanguage}
                                    >
                                      <strong>{language.label}</strong>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="10"
                                        height="9"
                                        viewBox="0 0 10 9"
                                        fill="none"
                                      >
                                        <path
                                          d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                          stroke="#213248"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        ></path>
                                      </svg>
                                    </button>
                                  );
                                })}
                            </div>
                          )}
                        </div>
                        <div className="global-dropdown-block flex-center focus-target-lang">
                          <label>
                            {translate("cust_vendor.facet_target_language")}
                          </label>
                          <Select
                            aria-label="To Target Language"
                            classNamePrefix="cw"
                            className="global-dropdown-select"
                            menuShouldScrollIntoView={false}
                            closeMenuOnSelect={true}
                            options={targetLanguages}
                            isDisabled={
                              selectedSourceLanguage.length === 0 ||
                              selectedTargetLanguages.length > 4
                                ? true
                                : false
                            }
                            value={{
                              label: translate(
                                "cust_vendor.select_target_language_placeholder"
                              ),
                              value: Constants.BLANK,
                            }}
                            onChange={(value) =>
                              updateSelectedTargetLanguages(value)
                            }
                          />
                          <div className="multiselect-output flex">
                            {selectedTargetLanguages &&
                              selectedTargetLanguages.map((language) => {
                                return (
                                  <button
                                    aria-label={
                                      "Remove " +
                                      selectedSourceLanguage[0].label +
                                      " to " +
                                      language.label
                                    }
                                    onClick={() =>
                                      removeSelectedTargetLanguage(language)
                                    }
                                    onKeyDown={(e) =>
                                      removeSelectedLanguageonKeydown(language)
                                    }
                                  >
                                    <strong>
                                      {selectedSourceLanguage[0].label} to{" "}
                                      {language.label}
                                    </strong>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="10"
                                      height="9"
                                      viewBox="0 0 10 9"
                                      fill="none"
                                    >
                                      <path
                                        d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                        stroke="#213248"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                    </svg>
                                  </button>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="support-lang-pairs profile-editonly-block">
                  <fieldset className="role-and-department">
                    <legend className="heading-width-border">
                      {translate("cust_vendor.facet_translator_type")}
                    </legend>
                    <div className="profile-edit-form">
                      <div className="permission-list">
                        <div className="form-check small-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="facet_preferred_show"
                            id="facet_preferred_show"
                            disabled={false}
                            checked={selectPreferredVendor}
                            onChange={(e) => updatePreferredVendorSelection(e)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="facet_preferred_show"
                          >
                            {translate("cust_vendor.facet_preferred_vendor")}
                          </label>
                        </div>
                      </div>
                      <div className="permission-list">
                        <div className="form-check small-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="facet_preferred_show_non"
                            id="facet_preferred_show_non"
                            disabled={false}
                            checked={selectNotPreferredVendor}
                            onChange={(e) => updatePreferredVendorSelection(e)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="facet_preferred_show_non"
                          >
                            {translate(
                              "cust_vendor.facet_not_preferred_vendor"
                            )}
                          </label>
                        </div>
                      </div>
                      {bootstrapData?.features?.INTERNAL_TRANSLATORS && (
                        <div className="permission-list">
                          <div className="form-check small-checkbox">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="facet_internal_translator"
                              id="facet_internal_translator"
                              disabled={false}
                              checked={selectInternalTranslator}
                              onChange={(e) =>
                                setSelectInternalTranslator(e.target.checked)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="facet_internal_translator"
                            >
                              {translate(
                                "cust_vendor.facet_internal_translator"
                              )}
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  </fieldset>
                </div>
              </div>
              <div className="profile-editonly-block">
                <div className="role-and-department">
                  <h5 className="heading-width-border changebottom-color">
                    {translate("cust_vendor.facet_supported_industries")}
                  </h5>
                  <div className="profile-edit-form">
                    <div className="flex mar-bot10 gap20 align-items">
                      <div className="global-dropdown-block flex-center mb-0 breakselect">
                        <Select
                          aria-label="Supported Industries"
                          classNamePrefix="cw"
                          className="global-dropdown-select"
                          menuShouldScrollIntoView={false}
                          closeMenuOnSelect={true}
                          value={{
                            label: "Type or select an industry",
                            value: Constants.BLANK,
                          }}
                          options={industries}
                          onChange={(value) => updateSelectedIndustries(value)}
                        />
                         <div className="vendor-link ml-15">
                          <div className="relative tringle-position">
                            <div className="knowMore knowMoreFocus" role="button" tabIndex="0"
                             aria-expanded={isTooltipVisible ? "true" : "false"}
                             onClick={handleTooltipToggle}
                             onKeyDown={(e) => EnterTooltipToggle(e)}
                             aria-label={'tooltip '+ translate("cust_vendor.already_have_a_vendor_heading")}
                            >
                              {translate(
                                "cust_vendor.already_have_a_vendor_heading"
                              )}
                            </div>
                            <div
                              className={isTooltipVisible ? "wrap-tooltip-content show" : "wrap-tooltip-content"}
                              id="targetDescription"
                              onKeyDown={(e) => handleTooltipFocus(e)}
                           >
                              <div className="gb-tooltip-content">
                                <div className="triangle"></div>
                                <p>
                                  {translate(
                                    "cust_vendor.already_have_a_vendor_text"
                                  )}
                                </p>
                                <a
                                id="letUsKnow"
                                  href={
                                    "mailto:support@cloudwords.com?subject=Please add my vendor to " +
                                    humanize(bootstrapData?.brand)
                                  }
                                >
                                  {translate(
                                    "cust_vendor.already_have_a_vendor_footer"
                                  )}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="multiselect-output flex mar-bot16">
                      {selectedIndustries &&
                        selectedIndustries.map((industry) => {
                          return (
                            <button
                              aria-label={"Remove " + industry.label}
                              onClick={() => removeSelectedIndustry(industry)}
                              onKeyDown={(e) =>
                                removeSelectedOnKeydown(industry)
                              }
                            >
                              <strong>{industry.label}</strong>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="9"
                                viewBox="0 0 10 9"
                                fill="none"
                              >
                                <path
                                  d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                  stroke="#213248"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </button>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="white-bg mar-bot50">
                <div className="customer-vendor-content">
                  <ul className="customer-vendor-list">
                    {vendors?.length > 0 &&
                      vendors.map((vendor) => {
                        return (
                          <li>
                            <div className="image-block">
                              <figure>
                                <img
                                  src={
                                    vendor.logoPath !== Constants.BLANK
                                      ? vendor.logoPath
                                      : images.DEFAULT_VENDOR_LOGO
                                  }
                                  alt={vendor.name}
                                />
                              </figure>
                            </div>
                            <div className="desc-content">
                              <div>
                                <Link
                                  target={"_blank"}
                                  to={
                                    vendor.roleType.value !==
                                    Constants.ROLE_INTERNAL_TRANSLATOR
                                      ? `/vendors/${vendor.id}`
                                      : `/settings/my-account-profile/${vendor.id}`
                                  }
                                >
                                  <strong>{vendor.name}</strong>
                                </Link>
                              </div>
                              <p>
                                {vendor.roleType.value !==
                                Constants.ROLE_INTERNAL_TRANSLATOR
                                  ? vendor.description
                                  : translate(
                                      "cust_vendor.facet_internal_translator"
                                    )}
                              </p>
                              <h5>
                                {translate(
                                  "cust_vendor.vendor_detail_industries"
                                )}
                              </h5>
                              <p>
                                {Object.keys(vendorIndustries).map((key) => {
                                  if (key === "industry-" + vendor.id) {
                                    if (
                                      Object.keys(vendorIndustries[key])
                                        .length !== 0
                                    ) {
                                      return vendorIndustries[key].map(
                                        (industry, index) => {
                                          return (
                                            industry.display +
                                            (index !==
                                            vendorIndustries[key].length - 1
                                              ? ", "
                                              : " ")
                                          );
                                        }
                                      );
                                    } else {
                                      return <p>{Constants.NOT_APPLICABLE}</p>;
                                    }
                                  }
                                })}
                              </p>
                              <h5>
                                {translate(
                                  "cust_vendor.vendor_detail_top_language_pairs"
                                )}
                              </h5>
                              {Object.keys(topLanguagePairs).map((key) => {
                                if (key === vendor.id.toString()) {
                                  if (
                                    Object.keys(topLanguagePairs[key])
                                      .length !== 0
                                  ) {
                                    return Object.keys(
                                      topLanguagePairs[key]
                                    ).map((source) => {
                                      return (
                                        <p>
                                          <strong>{source}</strong> to :&nbsp;
                                          {topLanguagePairs[key][source].map(
                                            (targets, index) => {
                                              return (
                                                <span>
                                                  {targets.target.display +
                                                    (index !==
                                                    topLanguagePairs[key][
                                                      source
                                                    ].length -
                                                      1
                                                      ? ", "
                                                      : " ")}
                                                </span>
                                              );
                                            }
                                          )}
                                        </p>
                                      );
                                    });
                                  } else {
                                    return <p>{Constants.NOT_APPLICABLE}</p>;
                                  }
                                }
                              })}

                              <h5>
                                {translate(
                                  "cust_vendor.vendor_detail_preferred_by"
                                )}
                              </h5>
                              <div className="preferby flex">
                                <div className="multiselect-output flex">
                                  {vendor?.userGroups?.length > 0 &&
                                    vendor?.userGroups?.map(
                                      (userGroup, index) => {
                                        return (
                                          <span>
                                            {userGroup.name}
                                            <span aria-hidden="true">
                                              {index !==
                                              vendor?.userGroups?.length - 1
                                                ? ","
                                                : ""}
                                            </span>
                                            &nbsp;
                                          </span>
                                        );
                                      }
                                    )}
                                </div>
                                {vendor.roleType.value !==
                                Constants.ROLE_INTERNAL_TRANSLATOR ? (
                                  <button
                                    aria-label={translate(
                                      "cust_vendor.vendor_detail_edit_department"
                                    )}
                                    className="name-edit inline-flex btnClick"
                                    onClick={(e) =>
                                      showIntendentModel(e, vendor)
                                    }
                                    onKeyDown={(e) =>
                                      showIntendentModelonKeydown(e, vendor)
                                    }
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="17"
                                      viewBox="0 0 18 17"
                                      fill="none"
                                      className="aaa-change-icon"
                                    >
                                      <path
                                        d="M0.25 15.25H17.75V16.5H0.25V15.25ZM14.875 4.625C15.375 4.125 15.375 3.375 14.875 2.875L12.625 0.625C12.125 0.125 11.375 0.125 10.875 0.625L1.5 10V14H5.5L14.875 4.625ZM11.75 1.5L14 3.75L12.125 5.625L9.875 3.375L11.75 1.5ZM2.75 12.75V10.5L9 4.25L11.25 6.5L5 12.75H2.75Z"
                                        fill="#1D4ED8"
                                      />
                                    </svg>
                                  </button>
                                ) : (
                                  <button
                                    aria-label={translate(
                                      "cust_vendor.vendor_detail_edit_department"
                                    )}
                                    className="name-edit inline-flex"
                                    onClick={() =>
                                      navigate(
                                        `/settings/my-account-profile/${vendor.id}`
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (e.key === Constants.ENTER) {
                                        navigate(
                                          `/settings/my-account-profile/${vendor.id}`
                                        );
                                      }
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="17"
                                      viewBox="0 0 18 17"
                                      fill="none"
                                      className="aaa-change-icon"
                                    >
                                      <path
                                        d="M0.25 15.25H17.75V16.5H0.25V15.25ZM14.875 4.625C15.375 4.125 15.375 3.375 14.875 2.875L12.625 0.625C12.125 0.125 11.375 0.125 10.875 0.625L1.5 10V14H5.5L14.875 4.625ZM11.75 1.5L14 3.75L12.125 5.625L9.875 3.375L11.75 1.5ZM2.75 12.75V10.5L9 4.25L11.25 6.5L5 12.75H2.75Z"
                                        fill="#1D4ED8"
                                      />
                                    </svg>
                                  </button>
                                )}
                              </div>
                            </div>
                          </li>
                        );
                      })}
                    
                  </ul>
                  {(vendors === undefined || vendors?.length === 0) && (
                      <p>{translate("cust_vendor.no_data_text")}</p>
                    )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div
        className="lightbox-panel"
        aria-labelledby="renamelabel"
        aria-modal="true"
        role="dialog"
      >
        <div className="inner-lightbox-panel pb-0">
          <div className="modal-header flex padd-lr">
            <h5 id="renamelabel">
              {translate("cust_vendor.department_popup_heading")}
            </h5>
          </div>
          <div className="lightbox-content padd-22">
            <h6 className="mar-bot20">
              For which department should <span>{activePopupVendorName}</span>{" "}
              be preferred?
            </h6>
            <div className="flex wrap-dropdown mb-0">
              <div className="global-dropdown-block">
                <label>{translate("cust_vendor.departments_select")}</label>
                <Select
                  classNamePrefix="cw"
                  className="w-100 hide"
                  aria-label="Department"
                  id="addDepartment"
                  menuShouldScrollIntoView={false}
                  closeMenuOnSelect={true}
                  options={unassignedDepartments}
                  value={{
                    label: `${t("select_one_department")}`,
                    value: Constants.BLANK,
                  }}
                  onChange={(value) => handleDepartmentSelection(value)}
                />
                <div className="multiselect-output flex">
                  {preferredVendorDepartments?.map((userGroup) => {
                    return (
                      <button
                        onClick={(e) => removeDepartment(userGroup)}
                        onKeyDown={(e) => removeDepartmentonKeydown(userGroup)}
                        aria-label={"Remove " + userGroup.name}
                      >
                        <strong>{userGroup.name}</strong>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="9"
                          viewBox="0 0 10 9"
                          fill="none"
                        >
                          <path
                            d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                            stroke="#213248"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer modal-footer-border flex px-22">
            <button
              className="btn btn-bold first-focus"
              onClick={hideIntendentModel}
              //onKeyDown={(e) => hideIntendentModelonKeydown}
            >
              {translate("button_cancel")}
            </button>
            <button
              id="saveId"
              className="btn btn-bold active"
              onClick={updatePreferredVendors}
              onKeyDown={handleKeyOkflow}
            >
              {translate("button_save")}
            </button>
          </div>
        </div>
      </div>
      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
        <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>
    </div>
  );
}
